jQuery(function($){
  // Collapse ////////////////////////////////////////////////////////
    // Initialized collapse elements
    setTimeout(() => {
      $('.collapse').each(function () {
        var elm = $(this);
        var h = elm[0].scrollHeight;
  
        elm[0].style.height = h + 'px';
      });
    }, 1000);

    // When collapse toggle is clicked
    $('body').on('click', '.collapse-toggle', function () {
      var toggle = $(this);
      var group = $(this).data('group');
      var target = $($(this).data('target'));
      var limit = $(this).data('limit');

      if (limit === 'any') {
        if (!toggle.hasClass('active')) {
          $(group+'.collapse-toggle.active').removeClass('active');
          $(group+'.collapse').not('.close').addClass('close');
        }
  
        target.addClass('overflow-hidden');
        setTimeout(() => {
          target.toggleClass('close');
          toggle.toggleClass('active');
        }, 10);
      } else {
        $(group+'.collapse-toggle').removeClass('active');
        toggle.addClass('active');
        $(group+'.collapse').addClass('close');
        target.removeClass('close');

        setTimeout(() => {
          target.removeClass('overflow-hidden');
        }, 10);
      }

      var slickTarget = $(this).data('slick');
      
      if (slickTarget !== undefined) {
        var slideIndex = $(this).data('goto');

        $(slickTarget).slick('slickGoTo', (parseInt(slideIndex)));
      }
    });

    // When window resize update collapse element height
    $(window).on('resize', function () {
      $('.collapse').each(function () {
        var elm = $(this);

        elm[0].style.height = 'auto';

        var h = elm[0].scrollHeight;

        elm[0].style.height = h + 'px';
      });
    });
    // Collapse //////////////////////////////////////////////////////// END
});
